import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AppState } from '../../core/app-state';
import { BuildingDoc, BuildingService } from '../../core/services';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { RxdbBuildingsEditComponent } from '../rxdb-buildings-edit/rxdb-buildings-edit.component';

@Component({
  selector: 'app-rxdb-buildings-view',
  templateUrl: './rxdb-buildings-view.component.html',
  styleUrls: ['./rxdb-buildings-view.component.css']
})
export class RxdbBuildingsViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  isLoading : boolean = false;
  errorMsg: string = "";
  bSyncing: boolean = false;

  constructor(appState: AppState,
    private buildingService : BuildingService,
    private modalService: BsModalService,
    private router: Router ) {
    super(appState)
  }

  ngOnInit(): void {
    this.buildingService.doWhenReady( () => this.loadBuildings() )
  }

  ngOnDestroy(): void {
    this.destroy()
    this.buildingSubscription?.unsubscribe()
  }

  rxBuildings : BuildingDoc[] = []
  buildingSubscription: Subscription

  async loadBuildings() {
    this.errorMsg = ""
    this.rxBuildings = []

    this.isLoading = true
    try {
      const buildingSubject = this.buildingService.rxCollection.find().$;
      this.buildingSubscription?.unsubscribe();
      this.buildingSubscription = buildingSubject.subscribe( (buildings)=>{
        this.rxBuildings= buildings
        this.isLoading=false;
      });
    } catch ( error ) {
      this.errorMsg = this.buildingService.extractErrorMsg(error)
    }
  }

  async clearBuildings() {
    let initialState = {
      onYes: async () => {
        await this.buildingService.rxCollection.remove().then(async () => {
          console.log('rxCollection remove()')
        }).catch(error => {
          console.log('clearBuildings() Error: ', error)
        }).finally(() => {
          // location.reload()
          this.router.navigate(['']).then(() => {
            location.reload();
          });
        })
      },
      title: "RxDB Buildings Rebuild",
      question: `Do you wish to rebuild Building Database?  `
        + `<div class="m-2 small font-italic text-warning"><i class='text-warning fa fa-info-circle mr-1'></i>It may take a few minutes to re-sync Building Data</div>`
        + `<div>Rebuild now?</div>`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.show(ConfirmModalComponent, {ignoreBackdropClick: true,initialState} );
  }

  editBuilding(buildingDoc: BuildingDoc) {
    const initialState = {
      building: buildingDoc
    }
    this.modalService.show(RxdbBuildingsEditComponent, {ignoreBackdropClick: true, initialState});
  }
}
